// Override ember-composable-helpers' sort-by with our custom version
// that supports EmberData PromiseManyArray
export { default } from 'bullitttime-embercomponents/helpers/sort-by';
